// extracted by mini-css-extract-plugin
export default {"discountTab":"discount_discountTab__iFvSv"};